// Shared mutable state for the playground. All modules import from here.

export let editor = null;
export let codePreview = null;

// Formats rendered through the read-only code-preview EditorView (code-preview.js)
// rather than the visual iframe/img preview (preview.js).
export const CODE_FORMATS = new Set(['json', 'text', 'yaml', 'data']);

// SQL block-scalar keys (e.g. ['sql', 'query']), fetched once by editor.js and
// shared with code-preview.js so both editors nest the same SQL highlighting.
export let sqlBlocks = null;

export let ws = null;
export let reconnectTimeout = null;
export let currentExamplePath = null;
export let currentVariables = {};
// Set by each sendYAMLToPreview(); read by updatePreview().
export let renderKeepsBoard = false;
export let shouldResetScrollOnNextUpdate = true;
export let examplesData = [];
export let playgroundConfig = { diagnostic_display: {}, projects: [], active_project: 0 };

// The active project is the ?project=<index> query param (index into the
// server's DCT_PLAYGROUND_PROJECTS list). Absent means index 0. Every API/WS
// URL carries it so the request hits the right project's registry + gallery.
export function activeProject() {
    return new URLSearchParams(window.location.search).get('project');
}

export function withProject(url) {
    const project = activeProject();
    if (project === null || project === '') return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}project=${encodeURIComponent(project)}`;
}

export const REVIEW_WIDTH_STORAGE_KEY = 'dbt-charts-playground-review-width';
export const PANE_SPLIT_STORAGE_KEY = 'dbt-charts-playground-editor-ratio';
export const PANE_SPLIT_MIN = 0.2;
export const PANE_SPLIT_MAX = 0.8;
export const PANE_SPLIT_DEFAULT = 0.5;
export const TERMINAL_FONT_STACK = "ui-monospace, 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace";
export const TERMINAL_PREVIEW_PAD_X = 40;
export const TERMINAL_PREVIEW_PAD_Y = 40;
export const TERMINAL_BOX_PAD_X = 32;
export const TERMINAL_BOX_PAD_Y = 32;
export const TERMINAL_MIN_COLS = 80;
export const TERMINAL_MAX_COLS = 400;
export const TERMINAL_MIN_ROWS = 24;
export const TERMINAL_MAX_ROWS = 200;

export let terminalCharProbe = null;
export let terminalRerenderTimeout = null;

// AI sidebar state
export let aiSidebarOpen = false;
export let conversationHistory = [];
export let selectedYamlContext = null;

// URL variables — stored during DOMContentLoaded, consumed once by example load
export let urlVariables = null;

// Setters for state that needs to be updated from multiple modules

export function setEditor(e) { editor = e; }
export function setCodePreview(cp) { codePreview = cp; }
export function setSqlBlocks(rules) { sqlBlocks = rules; }
export function setWs(w) { ws = w; }
export function setReconnectTimeout(t) { reconnectTimeout = t; }
export function setCurrentExamplePath(p) { currentExamplePath = p; }
export function setCurrentVariables(v) { currentVariables = v; }
export function setRenderKeepsBoard(v) { renderKeepsBoard = v; }
export function setShouldResetScrollOnNextUpdate(v) { shouldResetScrollOnNextUpdate = v; }
export function setExamplesData(d) { examplesData = d; }
export function setPlaygroundConfig(c) { playgroundConfig = c; }
export function setTerminalCharProbe(p) { terminalCharProbe = p; }
export function setTerminalRerenderTimeout(t) { terminalRerenderTimeout = t; }
export function setAiSidebarOpen(v) { aiSidebarOpen = v; }
export function setSelectedYamlContext(ctx) { selectedYamlContext = ctx; }
export function setUrlVariables(v) { urlVariables = v; }

// Slot for patchedUpdatePreview (celebration.js) registered by bootstrap.
// renderViaHTTP reads this to get the celebration-wrapped version when the WS is closed.
export let updatePreview = null;
export function setUpdatePreview(fn) { updatePreview = fn; }

// Callback for selecting an example from the gallery (closes modal, updates URL, triggers render).
// Set by loadExamples() so the dev-mode toggle can rebuild the gallery with the real callback.
export let gallerySelectFn = null;
export function setGallerySelectFn(fn) { gallerySelectFn = fn; }
